var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "select-search",
      style: {
        maxWidth: _vm.normalizedMaxWidth,
        minWidth: _vm.normalizedMinWidth
      }
    },
    [
      _c(
        "v-input",
        {
          ref: "input",
          attrs: {
            value: _vm.validationValue,
            rules: _vm.rules,
            "hide-details": !_vm.showDetails,
            disabled: _vm.disabled,
            loading: _vm.loading
          }
        },
        [
          _c(
            "v-menu",
            {
              attrs: {
                "close-on-content-click": false,
                transition: "scroll-y-transition",
                "max-width": _vm.normalizedMenuMaxWidth,
                "min-width": _vm.menuMinWidth,
                "min-height": "auto",
                "offset-y": "",
                "content-class": "select-search__menu rounded-xs",
                disabled: _vm.disabled
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c("div", { staticClass: "select-search__select" }, [
                          _vm.label
                            ? _c(
                                "span",
                                {
                                  staticClass: "text-sm",
                                  class: {
                                    "select-search__label--disabled":
                                      _vm.disabled
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.label) + " ")]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            _vm._g(
                              _vm._b(
                                {
                                  ref: "activator",
                                  staticClass:
                                    "select-search__input-container rounded-xs",
                                  class: {
                                    "select-search__input-container--active":
                                      _vm.show,
                                    "select-search__input-container--disabled":
                                      _vm.disabled
                                  }
                                },
                                "div",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _vm.$scopedSlots.selection
                                ? [_vm._t("selection")]
                                : _vm.selectionText
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "select-search__selection-text text-xs"
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.selectionText) + " "
                                        )
                                      ]
                                    )
                                  ]
                                : [
                                    _c("SelectedItemsDisplay", {
                                      attrs: {
                                        selectedItemsValues:
                                          _vm.selectedItemsValues,
                                        "default-text": _vm.selectionPlaceholder
                                      }
                                    })
                                  ],
                              _c(
                                "v-icon",
                                {
                                  staticClass: "select-search__icon",
                                  class: {
                                    "select-search__icon--active": _vm.show
                                  }
                                },
                                [_vm._v(" mdi-chevron-down ")]
                              )
                            ],
                            2
                          )
                        ])
                      ]
                    }
                  }
                ],
                null,
                true
              ),
              model: {
                value: _vm.show,
                callback: function($$v) {
                  _vm.show = $$v
                },
                expression: "show"
              }
            },
            [
              _c(
                "div",
                { staticClass: "select-search__modal bg-white" },
                [
                  _c("v-text-field", {
                    ref: "searchField",
                    staticClass: "select-search__search new-ux",
                    attrs: {
                      placeholder: _vm.placeholder || _vm.searchPlaceholder,
                      outlined: "",
                      autofocus: "",
                      disabled:
                        _vm.loading || _vm.disabled || _vm.isEmptySourceList
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  }),
                  _vm.showClearSelectedItems
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "text-primary text-xs text-underline text-bold text-right hover pr-4",
                          on: { click: _vm.clearSelectedItems }
                        },
                        [_vm._v(" Limpar seleção ")]
                      )
                    : _vm._e(),
                  _vm.showSelectedItemsList && !_vm.single
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "select-search__title-selected text-xxs"
                          },
                          [_vm._v(" Itens selecionados: ")]
                        ),
                        _c("div", { staticClass: "select-search__divider" })
                      ])
                    : _vm._e(),
                  _vm.showSelectedItemsList && !_vm.single
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "select-search__list-items select-search__list-items--permanent-selected"
                        },
                        _vm._l(_vm.permanentSelectedItems, function(item) {
                          return _c("div", { key: item.id }, [
                            _c(
                              "div",
                              [
                                _c("v-checkbox", {
                                  staticClass: "m-0 p-0",
                                  attrs: {
                                    value: item.id,
                                    label: _vm.$scopedSlots.item
                                      ? undefined
                                      : item.value,
                                    "hide-details": "",
                                    multiple: "",
                                    color: "primary"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleItemToggle(item.id)
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      _vm.$scopedSlots.item
                                        ? {
                                            key: "label",
                                            fn: function() {
                                              return [
                                                _vm._t("item", null, {
                                                  item: item
                                                })
                                              ]
                                            },
                                            proxy: true
                                          }
                                        : null
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.selectedItems,
                                    callback: function($$v) {
                                      _vm.selectedItems = $$v
                                    },
                                    expression: "selectedItems"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm.showSelectedItemsList && !_vm.single
                    ? _c("div", { staticClass: "select-search__divider" })
                    : _vm._e(),
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "full-center pt-3" },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              color: "primary",
                              indeterminate: "",
                              size: "40"
                            }
                          })
                        ],
                        1
                      )
                    : !_vm.isEmptyList && !_vm.isEmptySourceList
                    ? _c(
                        "div",
                        {
                          ref: "listContainer",
                          staticClass: "select-search__list-items",
                          class: {
                            "select-search__list-items--full": _vm.single
                          },
                          on: { scroll: _vm.handleScroll }
                        },
                        _vm._l(_vm.displayedItems, function(item) {
                          return _c(
                            "div",
                            {
                              key: item.id,
                              attrs: { "data-item-id": item.id }
                            },
                            [
                              !_vm.single
                                ? _c(
                                    "div",
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "m-0 p-0",
                                        attrs: {
                                          value: item.id,
                                          label: _vm.$scopedSlots.item
                                            ? undefined
                                            : item.value,
                                          "hide-details": "",
                                          multiple: "",
                                          color: "primary"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.handleItemToggle(item.id)
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            _vm.$scopedSlots.item
                                              ? {
                                                  key: "label",
                                                  fn: function() {
                                                    return [
                                                      _vm._t("item", null, {
                                                        item: item
                                                      })
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              : null
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.selectedItems,
                                          callback: function($$v) {
                                            _vm.selectedItems = $$v
                                          },
                                          expression: "selectedItems"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "select-search__option",
                                      class: {
                                        "select-search__option--selected": _vm.selectedItems.includes(
                                          item.id
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectSingle(item.id)
                                        }
                                      }
                                    },
                                    [
                                      _vm.$scopedSlots.item
                                        ? [_vm._t("item", null, { item: item })]
                                        : [
                                            _vm._v(
                                              " " + _vm._s(item.value) + " "
                                            )
                                          ]
                                    ],
                                    2
                                  )
                            ]
                          )
                        }),
                        0
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "select-search__empty text-sm text-center text-color-900"
                        },
                        [_vm._v(" Nenhum item encontrado. ")]
                      ),
                  _vm.$scopedSlots.footer
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-center justify-center pt-3 select-search__footer"
                        },
                        [_vm._t("footer")],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }